Jelly.Actions.Hide_Results = function(Parameters)
{	
	// Registers an action result element for a reference.
	// Parameters:  Namespace
	var Debug = false && Jelly.Debug.Debug_Mode;
	
	if (Debug)
	{
		Jelly.Debug.Group("Hide Results");
		Jelly.Debug.Log(Parameters);
	}
			
	// Get action reference
	var Action_Element = document.getElementById(Parameters["Namespace"]);
	var Action_Reference = Jelly.References.Get_Reference_For_Element(Action_Element);	
	if (!Jelly.Actions.Is_Action_Reference(Action_Reference))
		return;

	// Hide action result element.
	if (Action_Reference["Result_Element"]) { 
		var Result_Item = $(Action_Reference["Result_Element"]);
		Result_Item.hide();
		// if (Result_Item.css("display") != "none" && Result_Item.css("visibility") == "visible")
		// 	Result_Item.transition('horizontal flip out', '200ms');
	}
	
	// Hide action input result elements.
	for (var Input_Alias in Action_Reference.Inputs) {
		var Action_Input = Action_Reference.Inputs[Input_Alias];
		if (Action_Input["Result_Element"]) {
			var Result_Item = $(Action_Input["Result_Element"]);
			Result_Item.hide();
			// if (Result_Item.css("display") != "none" && Result_Item.css("visibility") == "visible")
			// 	Result_Item.transition('horizontal flip out', '200ms');
		}
	}

	if (Debug)
	{
		Jelly.Debug.End_Group("");
	}
};